export default __webpack_public_path__ + "static/media/logo_fester_header.0ce081e3.png";